import { css, useTheme } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useCallback } from 'react';

import { useSDK } from '../../app';
import { styled } from '../../styled';
import { Theme } from '../../theme/interface/detailed';
import { VideoIcon } from '../videoIcon';

type Interface = {
	className: string;
};

const Component = ({ className }: Interface): ReactElement => {
	const theme = useTheme() as Theme;
	const rootStore = useSDK();
	const { conversationsStore, uiStateStore, videoCallsStore } = rootStore;

	const call = useCallback(async () => {
		if (conversationsStore.isLatestConversationResolved) {
			uiStateStore.resetState();
			await rootStore.startNewVideoConversation();
			if (!rootStore.startNewConversationRequestStatus.isLoaded) {
				return;
			}
		}
		uiStateStore.setOpened(true);
		videoCallsStore.createOffer();
	}, [rootStore, conversationsStore, uiStateStore, videoCallsStore]);

	return (
		<div className={className}>
			<VideoIcon
				disabled={false}
				className="startVideoIcon"
				fill={theme.allSettings.icons.startVideocallIcon.fill}
				onClick={call}
			/>
		</div>
	);
};

export const StartVideoIcon = styled(observer(Component))(
	({ theme }: { theme: Theme }) => theme.allSettings.icons.startVideocallIcon,
	css`
		border-radius: 30px;
		padding: 13.5px;

		& svg {
			height: 100%;
			transform: scale(1.25, 1.25);
			width: 100%;
		}
	`
);
